<div class="flex p-3 gap-2 bg-white justify-between rounded-sm">
  <div
    class="h-6 w-6 shrink-0 bg-neutral-20 rounded flex items-center justify-center"
  >
    @switch (opportunity().status) {
      @case (OpportunityStatus.New) {
        <span
          class="fa-icons icon-16 icon-circle-star flex text-info-80"
        ></span>
      }
      @case (OpportunityStatus.Updated) {
        <span class="fa-icons icon-16 icon-building flex"></span>
      }
      @case (OpportunityStatus.Won) {
        <span
          class="fa-icons icon-16 icon-solid text-finserv-100 icon-circle-check flex"
        ></span>
      }
      @case (OpportunityStatus.Lost) {
        <span
          class="fa-icons icon-16 icon-solid text-error icon-circle-x flex"
        ></span>
      }
      @case (OpportunityStatus.Suspended) {
        <span
          class="fa-icons icon-16 icon-solid text-error icon-circle-exclamation flex"
        ></span>
      }
      @case (OpportunityStatus.Abandoned) {
        <span
          class="fa-icons icon-16 icon-solid text-error icon-do-not-enter flex"
        ></span>
      }
      @default {
        <span
          class="svg-icons icon-opportunity-in-progress icon-16 flex"
        ></span>
      }
    }
  </div>
  <div class="min-w-0 flex-1 flex flex-col gap-y-1">
    <a
      kendoTooltip
      class="text-link text-body bold line-clamp-2 w-fit max-w-full"
      [href]="deepLink()"
      [callout]="false"
      [tooltipTemplate]="tooltipTemplate"
      [title]="
        'outlook.buttons.openInMaximizerTooltip'
          | translate: { entry: 'outlook.entries.opportunity' | translate }
      "
      target="_blank"
      rel="noopener"
      [innerHTML]="
        opportunity().objective
          | highlightSearchText: outlookStore.relatedSearchPhrase() ?? ''
      "
      [attr.aria-label]="opportunity().objective"
    ></a>
    <p
      class="caption line-clamp-1"
      [innerHTML]="
        opportunity().abEntry.companyName
          | highlightSearchText: outlookStore.relatedSearchPhrase() ?? ''
      "
    ></p>

    @if (opportunity().currentStage) {
      <p class="caption text-neutral-70 line-clamp-2">
        {{ 'outlook.opportunity.stage' | translate }}:
        {{ opportunity().currentStage }}
      </p>
    }

    @if (opportunity().contact?.firstName || opportunity().contact?.lastName) {
      <p class="caption text-neutral-70 line-clamp-2">
        {{ 'outlook.opportunity.contact' | translate }}:
        <span
          [innerHTML]="
            opportunity().contact?.firstName +
              ' ' +
              opportunity().contact?.lastName
              | highlightSearchText: outlookStore.relatedSearchPhrase() ?? ''
          "
        >
        </span>
      </p>
    }
    @if (opportunity().startDate) {
      <p class="caption text-neutral-70 line-clamp-2">
        {{ 'outlook.opportunity.startDate' | translate }}:
        {{ opportunity().startDate }}
      </p>
    }
    @if (opportunity().closeDate) {
      <p class="caption text-neutral-70 line-clamp-2">
        {{ 'outlook.opportunity.closeDate' | translate }}:
        {{ opportunity().closeDate }}
      </p>
    }
    @if (opportunity().forecastRevenue?.DisplayValue) {
      <p class="caption text-neutral-70 line-clamp-2">
        {{ opportunity().forecastRevenue?.DisplayValue }}
      </p>
    }
    @if (opportunity().owner) {
      <div>
        <p class="text-body py-1">
          {{ 'outlook.opportunity.owner' | translate }}:
        </p>
        <div class="flex items-center">
          <span class="avatar avatar-xs">{{
            opportunity().owner.display | nameInitials
          }}</span>
          <p class="text-body pl-1">{{ opportunity().owner.display }}</p>
        </div>
      </div>
    }
  </div>
  <span
    kendoTooltip
    class="h-fit shrink-0"
    [callout]="false"
    [tooltipTemplate]="tooltipTemplate"
    [title]="saveTooltipMessage"
  >
    <button
      kendoButton
      id="outlook-opportunity-ui-opportunityCard-saveEmail-{{
        opportunity().key
      }}"
      themeColor="primary"
      fillMode="flat"
      [disabled]="isSaveDisabled"
      (click)="save.emit(opportunity().key)"
      [iconClass]="saveIconClass"
    ></button>
  </span>
</div>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
